var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-main"},[_c('tag-views'),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_c('router-view',{staticStyle:{"padding-top":"45px"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }